import { rest } from 'msw';

import { getProfiles } from './profiles/profiles';

const URL_BASE = `${process.env.REACT_APP_BASE_URL_API}/api`;

export const employees = [rest.get(`${URL_BASE}/v1/users/profiles/`, getProfiles)];
